/* eslint-disable */
import React,{ useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import styles from './Forms.css';
import TextInput from '../../containers/Forms/components/TextInput';
import FormattedDate from '../../../views/components/Common/FormattedDate';
import { forEach } from 'lodash';
import { getEosSumaryReportStatus, getEosReportDownload } from "../../pages/PatientFile/module";

const KardiaRxReport = (props) => {
  const dispatch = useDispatch();
  const tempIdtfConnection = props.location.search.split('idtf_connection_id=');
  useEffect(() => {
    dispatch(getEosSumaryReportStatus(tempIdtfConnection[1]));
  }, []);
  const me = useSelector(state => state.app.dataSources.me);
  const KardiaRxECGs = useSelector(state => state.kardiaRx.kardiaRxIDTFEcg);
  let totalRecodings = 0;
  let totalMdnRecordings = 0;
  const eosSummaryStatus = useSelector(state => state.patientFile.eosSummaryReportStatus);
  if (
    KardiaRxECGs.recordings &&
    KardiaRxECGs.recordings.data &&
    KardiaRxECGs.recordings.data.length &&
    KardiaRxECGs.recordings.data[0].length
  ) {
    totalRecodings = KardiaRxECGs.recordings.data[0].length;
    KardiaRxECGs.recordings.data[0].forEach(item => {
      if (item.acuity === 'mdn') {
        totalMdnRecordings = totalMdnRecordings + 1;
      }
    });
  }

  let serviceDate = null;
  if (
    KardiaRxECGs.recordings &&
    KardiaRxECGs.recordings.data &&
    KardiaRxECGs.recordings.data.length &&
    KardiaRxECGs.recordings.data[0].length &&
    KardiaRxECGs.recordings.data[0][0].date
  ) {
    serviceDate = KardiaRxECGs.recordings.data[0][0].date;
  }

  const handleClickReport = () => {
    // console.log("report=>>", "handle Report");
    dispatch(getEosReportDownload(tempIdtfConnection[1]));

  }

  return (
    <form>
      <div className={styles.reportFormSection}>
        <div style={{ display: 'flex', marginTop: '10px' }}>
          <p
            className={styles.label}
            style={{ display: 'grid', width: '25vh' }}
          >
            EOS Summary Report
            <span>
             { eosSummaryStatus && eosSummaryStatus.status == 'ready' ?
                <button
                type="button"
                className={styles.pendingReport}
                // onClick={() => this.toggleRevokePopover()}
                data-action="button-cancel-order"
                data-label="Pending"
              >
                Ready
              </button> :
               <button
               type="button"
               className={styles.pendingReport}
               disabled
               // onClick={() => this.toggleRevokePopover()}
               data-action="button-cancel-order"
               data-label="Pending"
             >
               Pending
             </button>
             }
            </span>
          </p>
          <p
            className={styles.label}
            style={{ display: 'grid', width: '25vh' }}
          >
            Service Period:
            {/* <span><FormattedDate date={serviceDate} /></span> */}
            <span className={styles.serviceColor}>{ eosSummaryStatus && eosSummaryStatus.startServicePeriod && moment(new Date(eosSummaryStatus.startServicePeriod)).format("MM-DD-YYYY")} - { eosSummaryStatus && eosSummaryStatus.endServicePeriod && moment(new Date(eosSummaryStatus.endServicePeriod)).format("MM-DD-YYYY") }</span>
          </p>
          <p
            className={styles.label}
            style={{ display: 'grid', width: '25vh' }}
          >
            Total Recordings:
            {/* <span>{totalRecodings}</span> */}
            <span className={styles.serviceColor}>{eosSummaryStatus && eosSummaryStatus.recordingsCountInfo && eosSummaryStatus.recordingsCountInfo.total}</span>
          </p>
          <p
            className={styles.label}
            style={{ display: 'grid', width: '25vh' }}
          >
            Total MDN:
            {/* <span>{totalMdnRecordings}</span> */}
            <span className={styles.serviceColor}>{eosSummaryStatus && eosSummaryStatus.recordingsCountInfo && eosSummaryStatus.recordingsCountInfo.mdn}</span>

          </p>
          <button
            type="button"
            style={{ marginTop: '20px' }}
            className={styles.viewReport}
            disabled ={ eosSummaryStatus && eosSummaryStatus.status=='ready' ? false : true}
            onClick={() => handleClickReport()}
            data-action="button-cancel-order"
            data-label="View Report"
          >
            View Report
          </button>
        </div>
      </div>
    </form>
  );
};

export default KardiaRxReport;



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/KardiaRxReport.jsx